<template>
  <a-card :bordered="false" :bodyStyle="{ padding: '0px' }">
    <div id="map-container">
      <div id="map"></div>
    </div>
  </a-card>
</template>

<script>
import { defineComponent, ref } from 'vue';
// import dayjs from 'dayjs';
import BMap from 'BMap';
// import { getbdmapLocation } from '@/api/accountlist';
import { getList } from '@/api/accountlist';
import { message } from 'ant-design-vue';
// 字典项
// import dic from '@/untils/Dic';
// 接口
// import { getList } from '@/api/onlinedistribution';
import icon6 from '@/assets/images/ditutuding.png';

export default defineComponent({
  name: 'OnlineDistribution',

  setup() {
    const socket = ref(null);
    const bdmap = ref(null);
    const allaccount = ref([]); // 当前系统的账号
    const flag = ref(true);
    // const accountlist = ref([]);// 通过websocket获取的账号信息

    // 覆盖物-点-样式
    const makersStyel = ref({
      labelStyle: {
        // 设置label的样式
        color: '#fff',
        fontSize: '16px',
        border: '1px solid #ededed',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
      },
      infoWindowOpts: {
        width: 250, // 信息窗口宽度
        height: 150, // 信息窗口高度
        title: '', // 信息窗口标题
        offset: new BMap.Size(5, 0 - 10),
      },
    });

    const showPoint = (accountlist) => {
      accountlist.forEach((item, index) => {
        // console.log(item);
        let point = new BMap.Point(
          parseFloat(item.Longitude),
          parseFloat(item.Latitude)
        );
        // console.log(flag.value && index == 0);
        if (flag.value && index == 0) {
          // 地图初始化ß
          bdmap.value.centerAndZoom(point, 13);
          flag.value = false;
        }
        // if (index == 0) {
        //   // 地图初始化
        //   bdmap.value.centerAndZoom(point, 13);
        // }
        let label = new BMap.Label(item.Name, {
          // 创建文本标注
          position: point, // 设置标注的地理位置
          offset: new BMap.Size(0 - 30, 0), // 设置标注的偏移量
        });
        label.setStyle(makersStyel.value.labelStyle);
        bdmap.value.addOverlay(label); // 将标注添加到地图中

        let myIcon = new BMap.Icon(icon6, new BMap.Size(32, 32), {
          anchor: new BMap.Size(15, 35),
          imageOffset: new BMap.Size(0, 0), // 设置图片偏移
        });

        // 创建标注对象并添加到地图 ,区分是否是固定姐
        let marker = new BMap.Marker(point, {
          icon: myIcon,
        });
        marker.addEventListener('click', function () {
          let infostr = `<div style="width:100%;height:140px;overflow:scroll">
                          <div>名称：${item.Name}</div>
                  <div>类型:${item.Type == '1' ? '基站' : '移动站'}</div>
                  <div>解算状态:${item.State == 4 ? '固定解' : '非固定解'}</div>
                  <div>B(N,DD):${item.Latitude}</div>
                  <div>L(E,DD):${item.Longitude}</div>
                  <div>H(m):${item.Alt}</div></div>`;
          let infoWindow = new BMap.InfoWindow(
            infostr,
            makersStyel.value.infoWindowOpts
          ); // 创建信息窗口对象
          bdmap.value.openInfoWindow(infoWindow, point); // 打开信息窗口
        });
        // markers.push(marker);
        // baseStation.value.push(marker);
        bdmap.value.addOverlay(marker);
      });
    };

    // 获取账号列表
    const getAccountList = async () => {
      const res = await getList({ current: 1, size: 9999 });
      if (res.code == 0) {
        // console.log(res);
        allaccount.value = res.data && res.data.length ? res.data : [];
      }
    };

    return {
      socket,
      bdmap,
      allaccount,
      getAccountList,
      showPoint,
    };
  },
  mounted() {
    // console.log('mounted');
    // 定义地图
    this.bdmap = new BMap.Map('map', { enableMapClick: false });
    // // 地图初始化
    this.bdmap.centerAndZoom(new BMap.Point(102.84093586, 24.925118499), 7);
    this.bdmap.enableScrollWheelZoom();
    // 建立websocket连接
    this.initWebsocket();
    // 获取账号列表
    this.getAccountList();
  },
  methods: {
    initWebsocket() {
      if (typeof WebSocket === 'undefined') {
        alert('您的浏览器不支持socket');
      } else {
        // 实例化socket
        this.socket = new WebSocket(process.env.VUE_APP_WEBSOCKET + 'webLBS');
        // console.log(this.socket);
        // 监听socket连接
        this.socket.onopen = this.websocketOpen;
        // 监听socket错误信息
        this.socket.onerror = this.websocketError;
        // 监听socket消息
        this.socket.onmessage = this.websocketMsg;
        // 监听socket关闭
        this.socket.onclose = this.websocketClose;
        if (this.socket.readyState == 3) {
          this.socket.open();
        }
      }
    },
    websocketOpen() {
      console.log('open');
      this.socket.send('GET,WEB.LBS.Online,ALL');
    },
    websocketError() {
      console.log('error');
      message.error('接口连接失败');
    },
    websocketMsg(event) {
      const list = JSON.parse(event.data);
      const locationlist = [];
      this.allaccount.forEach((item) => {
        list.forEach((aitem) => {
          if (item.userName == aitem.Name) {
            locationlist.push(aitem);
          }
        });
      });
      // console.log('locationlist', locationlist);
      this.showPoint(locationlist);
    },
    websocketClose() {
      console.log('close');
    },
  },
  unmounted() {
    this.socket.close();
  },
});
</script>
<style type="less" scoped>
#map-container,
#map {
  width: 100%;
  /* height: 500px; */
  /* height: 100vh; */
  height: calc(100vh - 64px);
}
</style>
